module.exports = __webpack_public_path__ + "static/media/intro.38afb519.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/intro.mp4
// module id = 732
// module chunks = 0